import { MutableRefObject, useEffect, useState } from 'react';

export default function useDropzoneArea(
  dropzoneArea: MutableRefObject<HTMLDivElement | null>
) {
  const [inDropzone, setInDropzone] = useState<boolean>(false);

  useEffect(() => {
    document.addEventListener('dragenter', handleDragEnterScreen);
    document.addEventListener('dragleave', handleDragLeaveScreen);
    document.addEventListener('drop', handleCancelDropFiles);
    if (dropzoneArea.current) {
      dropzoneArea.current.addEventListener(
        'dragenter',
        handleDragEnterDropArea
      );
      dropzoneArea.current.addEventListener(
        'dragleave',
        handleDragLeaveDropArea
      );
      dropzoneArea.current.addEventListener('drop', handleDropFiles);
    }

    return () => {
      document.removeEventListener('dragenter', handleDragEnterScreen);
      document.removeEventListener('dragleave', handleDragLeaveScreen);
      document.removeEventListener('drop', handleCancelDropFiles);
      if (dropzoneArea.current) {
        dropzoneArea.current.removeEventListener(
          'dragenter',
          handleDragEnterDropArea
        );
        dropzoneArea.current.removeEventListener(
          'dragleave',
          handleDragLeaveDropArea
        );
        dropzoneArea.current.removeEventListener('drop', handleDropFiles);
      }
    };
  }, []);

  function handleDragEnterScreen(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (dropzoneArea.current) {
      dropzoneArea.current.style.display = 'block';
    }
  }

  function handleDragLeaveScreen(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    // Check the cursor has to leave the screen
    if (
      event.clientX <= 0 ||
      event.clientY <= 0 ||
      event.clientX >= window.innerWidth ||
      event.clientY >= window.innerHeight
    ) {
      if (dropzoneArea.current) {
        dropzoneArea.current.style.display = 'none';
      }
    }
  }

  function handleCancelDropFiles(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (dropzoneArea.current) {
      dropzoneArea.current.style.display = 'none';
    }
  }

  function handleDragEnterDropArea(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    setInDropzone(true);
  }

  function handleDragLeaveDropArea(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    // Check the relatedTarget property of the event to ensure that it's leaving the dropzone area and not just entering a nested element within the dropzone.
    const dropzone = dropzoneArea.current;

    if (dropzone && !dropzone.contains(event.relatedTarget as Node)) {
      setInDropzone(false);
    }
  }

  function handleDropFiles(event: DragEvent): void {
    event.preventDefault();

    if (dropzoneArea.current) {
      dropzoneArea.current.style.display = 'none';
    }

    setInDropzone(false);
  }

  return { inDropzone };
}
